// extracted by mini-css-extract-plugin
export var aiChatCircle = "floating-ai-widget-module--aiChatCircle--f036c";
export var fadeIn = "floating-ai-widget-module--fadeIn--2bba1";
export var fadeOut = "floating-ai-widget-module--fadeOut--95944";
export var morph = "floating-ai-widget-module--morph--5cdc9";
export var pulse = "floating-ai-widget-module--pulse--d9c21";
export var wave = "floating-ai-widget-module--wave--4b495";
export var widgetContainer = "floating-ai-widget-module--widgetContainer--e1fc3";
export var widgetHidden = "floating-ai-widget-module--widgetHidden--dfe50";
export var widgetVisible = "floating-ai-widget-module--widgetVisible--58cb6";